import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import { SpacingProps } from '@sdk/components/ui/spacing/Spacing';

const SettingsSectionContainer = styled(Column)`
  flex-grow: 1;
  white-space: pre-line;
`;

type Props = {
  withSeparator?: boolean;
  children: React.ReactNode;
} & SpacingProps;

const SettingsSection = ({ withSeparator, children, ...props }: Props) => {
  return (
    <SettingsSectionContainer {...props}>
      {children}
      {withSeparator && (
        <Column mTop={20} mBottom={20}>
          <HorizontalSeparator />
        </Column>
      )}
    </SettingsSectionContainer>
  );
};

export default SettingsSection;
